import { render, staticRenderFns } from "./platType.vue?vue&type=template&id=d37ac518"
import script from "./platType.vue?vue&type=script&lang=js"
export * from "./platType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports